export default __webpack_public_path__ + "static/media/talk.a7237c6c.png";